/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	var windowW = $(window).width();
	var windowH = $(window).innerHeight();
	
	var _isSP;
	
	var windowW = window.innerWidth;
	var prewidth = window.innerWidth; //preload
	
	(0, _module.preload)(); //showMovie
	// import {showMovie} from "../include/module";
	// showMovie();
	//toggleHeader
	
	(0, _module.toggleHeader)(); //parallaxHennnyano
	
	(0, _module.parallaxHennnyano)(); // pageTop
	
	(0, _module.pageTop)(); // $(window).on('resize load' , function() {
	//   if(windowW <= 1024){
	//     _isSP = true;
	//   } else {
	//     _isSP = false;
	//   };
	//   //リサイズ処理 ブレイクポイントを跨いだらリロード
	//   var nowWidth = window.innerWidth;
	//   if(prewidth !== nowWidth){
	//     if(prewidth < 1025) {
	//       if(nowWidth >= 1025){
	//         location.reload();
	//       }
	//     }else {
	//       if(nowWidth < 1025){
	//         location.reload();
	//       }
	//     }
	//   };
	// });
	
	$(window).on('load', function () {
	  // scrollIndexAnime();
	  $('.sw-Lower, .sw-Lower_Wrapper').addClass("show");
	  setTimeout(function () {
	    $('.sw-Ttl').addClass("show");
	  }, 200);
	  setTimeout(function () {
	    $('#sw-Hennnyano').addClass("show");
	  }, 700);
	  showImg();
	  toggleProduce();
	}); // ------------------------------------------------------------------------
	// scrollIndexAnime
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var scrollIndexAnime = function scrollIndexAnime() {
	  var controller = new ScrollMagic.Controller(); //ヘッダー縮める
	
	  var scene = new ScrollMagic.Scene({
	    triggerElement: '.index-Keyvisual',
	    triggerHook: 0,
	    offset: '100'
	  }).setClassToggle('#st-Header,#st-Header_Logo', 'short') // .addIndicators({name: "1"})
	  .addTo(controller);
	}; // ------------------------------------------------------------------------
	// showImg
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	var showImg = function showImg() {
	  var $modal = $('#gallery-Modal');
	  var $img = $('#gallery-Modal_Img');
	  var $content = $('#gallery-Modal_Content');
	
	  var _currentNum; // open
	
	
	  $('.js-Img').on('click', function () {
	    var dataimg = $(this).attr('data-img'); //img append
	
	    $img.append('<img src="' + dataimg + '">');
	    $modal.addClass('is-show');
	    return false;
	  }); //close
	
	  $(' #gallery-Modal_Close-1, #gallery-Modal_Close-0').on('click', function () {
	    $modal.removeClass('is-show');
	    setTimeout(function () {
	      $img.children('img').remove();
	    }, 200);
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// toggleProduce
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	var toggleProduce = function toggleProduce() {
	  var contentsCount = $(".produce-List_Item").length;
	  var n = 4;
	
	  if (contentsCount <= n) {
	    $("#produce-List_Btn").hide();
	  } else {
	    $(".produce-List_Item").slice(n).hide();
	    $("#produce-List_Btn").click(function () {
	      if ($(".produce-List_Item").slice(n).is(':hidden')) {
	        $(".produce-List_Item").slice(n).slideDown(300);
	        $(this).addClass("open");
	      } else {
	        $(".produce-List_Item").slice(n).slideUp(300);
	        $(this).removeClass("open");
	      }
	    });
	  }
	};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pageTop = exports.parallaxHennnyano = exports.anchorLink = exports.showMovie = exports.toggleHeader = exports.preload = void 0;
	var headerFlag = false;
	var stHeader = document.getElementById('st-Header');
	var stHeaderNav = document.getElementById('st-Header_Nav');
	var stHeaderBg = document.getElementById('st-Header_Bg');
	var headerButton = document.getElementById('st-Menu'); // ------------------------------------------------------------------------
	// preload
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var preload = function preload() {
	  history.replaceState(null, null, null);
	  window.addEventListener('popstate', function () {
	    $('body').addClass('preload');
	    headerFlag = false;
	    stHeaderNav.classList.remove('opened');
	    headerButton.classList.remove('opened');
	    stHeaderBg.classList.remove('opened');
	    stHeaderNav.classList.add('closed');
	    headerButton.classList.add('closed');
	    stHeaderBg.classList.add('closed');
	    setTimeout(function () {
	      $('body').removeClass('preload');
	    }, 100);
	  }, false);
	  $(window).on('load', function () {
	    $("body").removeClass("preload");
	  });
	}; // ------------------------------------------------------------------------
	// toggleHeader
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.preload = preload;
	
	var toggleHeader = function toggleHeader() {
	  headerButton.addEventListener('click', function () {
	    if (!headerFlag) {
	      // $('#st-Header_Navi').css({'display':'block'});
	      setTimeout(function () {
	        stHeaderNav.classList.remove('closed');
	        headerButton.classList.remove('closed');
	        stHeaderBg.classList.remove('closed');
	        stHeaderNav.classList.add('opened');
	        headerButton.classList.add('opened');
	        stHeaderBg.classList.add('opened');
	        headerFlag = true;
	      }, 0);
	    } else {
	      stHeaderNav.classList.remove('opened');
	      headerButton.classList.remove('opened');
	      stHeaderBg.classList.remove('opened');
	      stHeaderNav.classList.add('closed');
	      headerButton.classList.add('closed');
	      stHeaderBg.classList.add('closed');
	      headerFlag = false; // setTimeout(function(){
	      //   // $('#st-Header_Navi').css({'display':'none'});
	      // },0);
	    }
	  }, false);
	}; // ------------------------------------------------------------------------
	// showMovie
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.toggleHeader = toggleHeader;
	
	var showMovie = function showMovie() {
	  var $modal = $('#sw-Youtube');
	  var $content = $('#sw-Youtube_Content'); // open
	
	  $('.js-Youtube').on('click', function () {
	    var dataID = $(this).attr('data-youtube');
	    $('#sw-Youtube').css({
	      'opacity': '0',
	      'display': 'block'
	    }).stop().animate({
	      'opacity': '1',
	      'width': 100 + '%',
	      'height': 100 + 'vh',
	      'top': 0,
	      'left': 0
	    }, 500, 'easeOutQuart', function () {
	      //iframe append
	      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/' + dataID + '?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>'); // fadeIn
	
	      $modal.stop().fadeIn(400);
	      return false;
	    });
	  }); //close
	
	  $('#sw-Youtube_Close,#sw-Youtube_Overlay').on('click', function () {
	    $('#sw-Youtube').css({
	      'opacity': '1'
	    }).stop().animate({
	      'opacity': '0'
	    }, 500, 'easeOutQuart', function () {
	      $('#sw-Youtube').css({
	        'display': 'none'
	      });
	      $content.children('iframe').remove();
	    });
	  });
	}; // ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.showMovie = showMovie;
	
	var anchorLink = function anchorLink() {
	  //ページ外からのページ内リンク
	  var urlHash = location.hash;
	
	  if (urlHash) {
	    $('body,html').stop().scrollTop(0);
	    setTimeout(function () {
	      var target = $(urlHash);
	      var position = target.offset().top - 80;
	      $('body,html').stop().animate({
	        scrollTop: position
	      }, 500);
	    }, 200);
	  }
	
	  var linkSpeed = 1000;
	  var linkAdjust = 50; //ページ内リンク
	
	  $("a[href^='#']").on("click", function () {
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({
	      scrollTop: linkPosition - linkAdjust
	    }, linkSpeed, "easeInOutQuint");
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// parallaxHennnyano
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.anchorLink = anchorLink;
	
	var parallaxHennnyano = function parallaxHennnyano() {
	  var layer = document.getElementById('sw-Hennnyano');
	  var parallax = new Parallax(layer, {
	    clipRelativeInput: true,
	    //要素の端にカーソルが達したら動きを止める
	    hoverOnly: false,
	    //カーソルが要素の上にある場合のみ有効
	    invertX: false,
	    //X軸の動きを反転。falseにするとマウスと同じ方向に動く
	    invertY: false,
	    //Y軸の動きを反転。falseにするとマウスと同じ方向に動く
	    limitX: true,
	    //X軸の動きを制限する
	    limitY: true,
	    //Y軸の動きを制限する
	    scalarX: 30.0,
	    //X軸の移動速度と範囲を増減
	    scalarY: 30.0,
	    //Y軸の移動速度と範囲を増減
	    frictionX: .1,
	    //X軸のレイヤーの速度。0.00〜1.00の範囲内で指定可能
	    frictionY: .1,
	    //Y軸のレイヤーの速度。0.00〜1.00の範囲内で指定可能
	    originX: .2,
	    //X軸のマウスの初期位置。デフォルトの0.5は画面または要素の中心
	    originY: 1 //Y軸マウスの初期位置。デフォルトの0.5は画面または要素の中心
	
	  });
	}; // ------------------------------------------------------------------------
	// pageTop
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.parallaxHennnyano = parallaxHennnyano;
	
	var pageTop = function pageTop() {
	  $("#sw-Hennnyano").on("click", function () {
	    var linkSpeed = 1200; // $("html, body").animate({scrollTop: 0}, linkSpeed, "easeOutExpo");
	    // return false;
	
	    setTimeout(function () {
	      $("html, body").animate({
	        scrollTop: 0
	      }, linkSpeed, "easeOutExpo");
	    }, 1000);
	    var windowH = $(window).innerHeight();
	    var hennnyanoH = $("#sw-Hennnyano").innerHeight();
	    var visibleHeight = hennnyanoH * .7;
	    var moveHeight = windowH + visibleHeight * 1.5;
	    var sinkHeight = hennnyanoH * .44;
	    anime({
	      targets: '#sw-Hennnyano',
	      translateY: [{
	        value: sinkHeight,
	        duration: 700,
	        delay: 0,
	        easing: 'easeInOutCubic'
	      }, // { value: 40, duration: 500, delay: 1000 },
	      {
	        value: -moveHeight,
	        duration: 1200,
	        delay: 200,
	        easing: 'easeOutCubic'
	      }, {
	        value: visibleHeight,
	        duration: 0,
	        delay: 0
	      }, {
	        value: 0,
	        duration: 1300,
	        delay: 0
	      }],
	      easing: 'easeOutElastic(1, .8)',
	      loop: false
	    });
	  });
	};
	
	exports.pageTop = pageTop;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// works/app.bundle.js